'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = snapshot;

var _debug = require('debug');

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var debug = (0, _debug2.default)('feathers-offline-snapshot');

function snapshot(service, baseQuery) {
  debug('start: ' + JSON.stringify(baseQuery));

  var query = Object.assign({}, { $skip: 0, $limit: 200 }, baseQuery); // use max recs configured
  var fileDatas = void 0;

  return service.find({ query: query }).then(function (result) {
    debug('read ' + (result.data || result).length + ' records');

    if (!result.data) {
      return result;
    }

    var total = result.total,
        limit = result.limit,
        skip = result.skip,
        data = result.data;

    fileDatas = data;

    return skip + data.length < total ? readRemainingPages(skip + limit) : fileDatas;
  });

  function readRemainingPages(skip) {
    query.$skip = skip;

    return service.find({ query: query }).then(function (_ref) {
      var total = _ref.total,
          limit = _ref.limit,
          skip = _ref.skip,
          data = _ref.data;

      debug('read ' + data.length + ' records');

      fileDatas = fileDatas.concat(data);

      return skip + data.length < total ? readRemainingPages(skip + limit) : fileDatas;
    });
  }
}
module.exports = exports['default'];